import jsonData from '../../sutta-title/components/SuttaTitle/index.json';
import { paliPathMap } from './paliPathMap'; // Import the new map

export type PathTitleMap = Record<string, string>;

export const generatePathTitleMap = (): PathTitleMap => {
  const titleMap: PathTitleMap = {};

  // Map nikaya abbreviations to full names used in URLs
  const nikayaUrlMap: Record<string, string> = {
    dn: 'dīghanikāya',
    mn: 'majjhimanikāya',
    sn: 'saṃyuttanikāya',
    an: 'aṅguttaranikāya',
  };

  const traverse = (node: any, path: string[] = []) => {
    if (typeof node === 'object' && node !== null) {
      // Store title for current path if exists and path is not empty
      if (node.title && path.length > 0) {
        const pathKey = path.join('/');
        titleMap[pathKey] = node.title;
        console.log(`🗺️  Mapped: "${pathKey}" → "${node.title}"`);
      }

      // Continue traversing
      Object.keys(node).forEach(key => {
        if (key === 'title') return;
        const nextPath = [...path, key];
        traverse(node[key], nextPath);
      });
    }
  };

  // Traverse each nikaya with BOTH abbreviation and full name
  Object.keys(jsonData).forEach(nikaya => {
    traverse((jsonData as any)[nikaya], [nikaya]);

    const fullName = nikayaUrlMap[nikaya];
    if (fullName && fullName !== nikaya) {
      traverse((jsonData as any)[nikaya], [fullName]);
    }
  });

  // Merge the manual Pāḷi path map into our generated map
  Object.assign(titleMap, paliPathMap);

  console.log(`✅ Map generated with ${Object.keys(titleMap).length} entries`);
  return titleMap;
};

export const pathTitleMap = generatePathTitleMap();
